module.exports = __webpack_public_path__ + "static/img/14.231e1e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/14.png
// module id = 8U4o
// module chunks = 0